
// Material Dashboard 2 PRO React components

// @mui icons
import Icon from "@mui/material/Icon";
import AccountSettings from "views/account/AccountSettings";
import ActionConsult from "views/legal/actions/action/ActionConsult";
import AreaConsult from "views/legal/area/AreaConsult";
import GroupsConsult from "views/legal/area/groups/GroupsConsult";
import ComplementVaraConsult from "views/legal/complementVara/ComplementVaraConsult";
import CampanhaConsult from "views/legal/campanhas/CampanhaConsult";
import ForumConsult from "views/legal/forum/ForumConsult";
import IndiceConsult from "views/legal/indice/IndiceConsult";
import OrgansConsult from "views/legal/organ/OrgansConsult";
import PessoaConsult from "views/legal/pessoa/PessoaConsult";
import ProcessFaseConsult from "views/legal/processFase/ProcessFaseConsult";
import FasePenhoraConsult from "views/legal/fasePenhora/FasePenhoraConsult";
import TipoBemPenhoraConsult from "views/legal/tipoBemPenhora/TipoBemPenhoraConsult";
import RisksConsult from "views/legal/risks/RisksConsult";
import TeamsConsult from "views/legal/teams/TeamsConsult";
import Cases from "views/legalConsult/cases/Cases";
import Casos from "views/legalConsult/cases/simple/Casos";
import ImportMovimentation from "views/legalConsult/importMovimentation/ImportMovimentation";
import SolicitacoesSystem from "views/legalConsult/Solicitacoes";
import BatchRescheduling from "views/legalConsult/batchRescheduling/BatchRescheduling";
import CompanyConsult from "views/processes/company/CompanyConsult";
import LawyersConsult from "views/processes/lawyers/LawyersConsult";
import ProcessConsult from "views/processes/process/ProcessConsult";
import LogRoboEditalConsult from "views/robots/logRoboEdital/LogRoboEditalConsult";
import LogRoboEmailsPushConsult from "views/robots/logRoboEmailsPush/LogRoboEmailsPushConsult";
import ComparadorRecortes from "views/robots/comparadorRecortes/ComparadorRecortes";
import MonitorRobos from "views/robots/monitorRobos/MonitorRobos";
import ProfileConsult from "views/tools/profiles/ProfileConsult";
import UsersConsult from "views/tools/users/UsersConsult";
import Tcd from "views/umc/tcd/Tcd";
import BaseDeDadosConsult from "views/umc/baseDeDados/BaseDeDadosConsult";
import TipoOcorrenciaConsult from "views/cadastroCobranca/tipoOcorrencia/TipoOcorrenciaConsult";
import ParametrizacaoSistema from "views/cadastroCobranca/parametrizacaoSistema/ParametrizacaoSistema";
import UsoIa from "views/tools/usoIa/UsoIa";
import StatusFichaConsult from "views/cadastroCobranca/statusFicha/StatusFichaConsult";
import MarcacaoEspecialConsult from "views/cadastroCobranca/marcacaoEspecial/MarcacaoEspecialConsult";
import MarcacaoContatosLoteConsult from "views/cadastroCobranca/marcacaoContatosLote/MarcacaoContatosLoteConsult";
import RecordingsConsult from "views/tools/recordings/RecordingsConsult";
import CredentialConsult from "views/tools/credentials/CredentialConsult";
import BaixaPagamentoConsult from "views/tools/baixaPagamento/BaixaPagamentoConsult";
import ContaBancariaConsult from "views/tools/contasBancarias/ContaBancariaConsult";
import RemessaImport from "views/umc/RemessaImport";
import MonitoriaSystem from "views/coordenador/monitoria/MonitoriaSystem";
import ReportsSystem from "views/coordenador/relatorios/ReportsSystem";
import ReportsCustom from "views/coordenador/relatorios/ReportsCustom";
import ExportarPrestacaoContas from "views/coordenador/relatorios/ExportarPrestacaoContas";
import BatimentoGetnet from "views/coordenador/relatorios/BatimentoGetnet";
import ComparativoBase from "views/coordenador/relatorios/ComparativoBase";
import AnaliseTempoSemestral from "views/coordenador/relatorios/AnaliseTempoSemestral";
import RegrasFilaConsult from "views/umc/regrasFila/RegrasFilaConsult";
import FilaProcessamento from "views/umc/filaProcessamento/FilaProcessamento";
import CnabSystem from "views/suporte/cnab/CnabSystem";
import RedistribuicaoCarteira from "views/suporte/redistribuicaoCarteira/RedistribuicaoCarteira";
import FilaTrabalho from "views/umc/filaTrabalho/FilaTrabalho";
import FilaSolicitacoesConsult from "views/umc/filaSolicitacoes/FilaSolicitacoesConsult";
import MinhasSolicitacoes from "views/umc/filaSolicitacoes/MinhasSolicitacoes";
import MigracoesJuridico from "views/umc/migracaoJuridico/MigracoesJuridico";
import MigracaoLegado from "views/tools/migracao/MigracaoLegado";
import MigracaoProcessos from "views/tools/migracao/MigracaoProcessos";
import MalaDiretaModelos from "views/umc/malaDireta/MalaDiretaModelos";
import MalaDiretaAnalise from "views/umc/malaDireta/MalaDiretaAnalise";
import MalaDiretaLote from "views/umc/malaDireta/MalaDiretaLote";
const routes = [
  {
    type: "collapse",
    name: "Meu Perfil",
    key: "username",
    icon: <Icon fontSize="medium">person</Icon>,
    route: "/pages/account-settings",
    component: <AccountSettings />,
    noCollapse: true
  },
  {
    type: "collapse",
    name: "Monitoria",
    key: "monitoria",
    menu: "c057",
    icon: <Icon fontSize="medium">insights</Icon>,
    route: "/pages/coordenador/monitoria",
    component: <MonitoriaSystem />,
    noCollapse: true
  },
  { type: "divider", key: "divider-0", noCollapse: true },
  {
    type: "collapse",
    name: "Gestão de Demandas",
    key: "legalConsult",
    icon: <Icon fontSize="medium">policy</Icon>,
    collapse: [
      {
        name: "Processos",
        key: "basicRegistration",
        menu: "c039",
        icon: <Icon fontSize="medium">gavel</Icon>,
        route: "/pages/tcd/process-system",
        component: <Cases />,
      },
      {
        name: "Casos",
        key: "casesRegistration",
        menu: "c044",
        icon: <Icon fontSize="medium">sticky_note_2</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <Casos />,
      },
      {
        name: "Solicitações",
        key: "solicitacoesSystem",
        menu: "c045",
        icon: <Icon fontSize="medium">note_add</Icon>,
        route: "/pages/solicitacoes/solicitacoes-system",
        component: <SolicitacoesSystem />,
      },
      {
        name: "Reagendamento em Lote",
        key: "batchRescheduling",
        menu: "c047",
        icon: <Icon fontSize="medium">event_repeat</Icon>,
        route: "/pages/tcd/batch-rescheduling",
        component: <BatchRescheduling />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Cobrança",
    key: "cobranca",
    icon: <Icon fontSize="medium">article</Icon>,
    collapse: [
      {
        name: "TCD",
        key: "tcd",
        menu: "c015",
        icon: <Icon fontSize="medium">sticky_note_2</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <Tcd />,
      },
      {
        name: "Base de Dados",
        key: "baseDeDados",
        menu: "c050",
        icon: <Icon fontSize="medium">storage</Icon>,
        route: "/pages/cobranca/base-de-dados",
        component: <BaseDeDadosConsult />,
      },
      {
        name: "Regras da Fila",
        key: "regras-fila",
        menu: "c064",
        icon: <Icon fontSize="medium">rule</Icon>,
        route: "/pages/cobranca/regras-fila",
        component: <RegrasFilaConsult />,
      },
      {
        name: "Processar Fila",
        key: "processar-fila",
        menu: "c065",
        icon: <Icon fontSize="medium">settings_applications</Icon>,
        route: "/pages/cobranca/processar-fila",
        component: <FilaProcessamento />,
      },
      {
        name: "Fila de Trabalho",
        key: "fila-trabalho",
        menu: "c066",
        icon: <Icon fontSize="medium">list_alt</Icon>,
        route: "/pages/cobranca/fila-de-trabalho",
        component: <FilaTrabalho />,
      },
      {
        name: "Solicitações ao Suporte",
        key: "solicitacoes-suporte",
        menu: "c089",
        icon: <Icon fontSize="medium">support_agent</Icon>,
        route: "/pages/cobranca/solicitacoes-suporte",
        component: <MinhasSolicitacoes />,
      },
      {
        name: "Migrações para o Jurídico",
        key: "migracoes-juridico",
        menu: "c090",
        icon: <Icon fontSize="medium">gavel</Icon>,
        route: "/pages/cobranca/migracoes-juridico",
        component: <MigracoesJuridico />,
      },
      {
        name: "Gestão de Contatos",
        key: "marcacaoContatosLote",
        menu: "c080",
        icon: <Icon fontSize="medium">contact_phone</Icon>,
        route: "/pages/cobranca/marcacao-contatos-lote",
        component: <MarcacaoContatosLoteConsult />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Mala Direta",
    key: "maladireta",
    icon: <Icon fontSize="medium">mail</Icon>,
    collapse: [
      {
        name: "Modelos de Mala Direta",
        key: "modelos-email",
        menu: "c069",
        icon: <Icon fontSize="medium">email</Icon>,
        route: "/marketing/modelos-email",
        component: <MalaDiretaModelos />,
      },
      {
        name: "Envio Mala Direta",
        key: "mala-direta-lote",
        menu: "c070",
        icon: <Icon fontSize="medium">send</Icon>,
        route: "/marketing/mala-direta-lote",
        component: <MalaDiretaLote />,
      },
      {
        name: "Análise da Mala Direta",
        key: "mala-direta-analise",
        menu: "c084",
        icon: <Icon fontSize="medium">insights</Icon>,
        route: "/marketing/mala-direta-analise",
        component: <MalaDiretaAnalise />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Relatórios",
    key: "relatorios_menu",
    icon: <Icon fontSize="medium">bar_chart</Icon>,
    collapse: [
      {
        name: "Relatórios e Indicadores",
        key: "relatorios",
        menu: "c058",
        icon: <Icon fontSize="medium">bar_chart</Icon>,
        route: "/pages/cobranca/relatorios",
        component: <ReportsSystem />,
      },
      {
        name: "Relatórios Customizados",
        key: "relatorios_customizados",
        menu: "c072",
        icon: <Icon fontSize="medium">tune</Icon>,
        route: "/pages/cobranca/relatorios-customizados",
        component: <ReportsCustom />,
      },
      {
        name: "Prestação de Contas",
        key: "exportar_pc",
        menu: "c078",
        icon: <Icon fontSize="medium">download</Icon>,
        route: "/pages/cobranca/prestacao-contas/exportar",
        component: <ExportarPrestacaoContas />,
      },
      {
        name: "Batimento (Getnet)",
        key: "batimento_getnet",
        menu: "c073",
        icon: <Icon fontSize="medium">sync_alt</Icon>,
        route: "/pages/cobranca/relatorios/batimento-getnet",
        component: <BatimentoGetnet />,
      },
      {
        name: "Comparativo de Base",
        key: "comparativo_base",
        menu: "c076",
        icon: <Icon fontSize="medium">compare_arrows</Icon>,
        route: "/pages/cobranca/relatorios/comparativo-base",
        component: <ComparativoBase />,
      },
      {
        name: "Análise de Atendimento",
        key: "analise_tempo_semestral",
        menu: "c081",
        icon: <Icon fontSize="medium">query_stats</Icon>,
        route: "/pages/cobranca/relatorios/analise-tempo-semestral",
        component: <AnaliseTempoSemestral />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Cadastro Geral",
    key: "cadastro_geral",
    icon: <Icon fontSize="medium">app_registration</Icon>,
    collapse: [
      {
        name: "Áreas",
        key: "areaType",
        menu: "c028",
        icon: <Icon fontSize="medium">sticky_note_2</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <AreaConsult />,
      },
      {
        name: "Grupos",
        key: "groupArea",
        menu: "c053",
        icon: <Icon fontSize="medium">sticky_note_2</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <GroupsConsult />,
      },
      {
        name: "Ações",
        key: "actionType",
        menu: "c033",
        icon: <Icon>sticky_note_2</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <ActionConsult />,
      },
      {
        name: "Complementos - Varas",
        key: "complementVara",
        menu: "c029",
        icon: <Icon>sticky_note_2</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <ComplementVaraConsult />,
      },
      {
        name: "Orgãos",
        key: "organ",
        menu: "c035",
        icon: <Icon fontSize="medium">sticky_note_2</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <OrgansConsult />,
      },
      {
        name: "Fase Processo",
        key: "processFase",
        menu: "c036",
        icon: <Icon fontSize="medium">sticky_note_2</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <ProcessFaseConsult />,
      },
      {
        name: "Fase Penhora",
        key: "fasePenhora",
        menu: "c048",
        icon: <Icon fontSize="medium">sticky_note_2</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <FasePenhoraConsult />,
      },
      {
        name: "Tipo Bem Penhora",
        key: "tipoBemPenhora",
        menu: "c049",
        icon: <Icon fontSize="medium">sticky_note_2</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <TipoBemPenhoraConsult />,
      },
      {
        name: "Riscos",
        key: "risk",
        menu: "c037",
        icon: <Icon fontSize="medium">sticky_note_2</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <RisksConsult />,
      },
      {
        name: "Índices",
        key: "indice",
        menu: "c040",
        icon: <Icon fontSize="medium">123</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <IndiceConsult />,
      },
      {
        name: "Fóruns",
        key: "forum",
        menu: "c042",
        icon: <Icon fontSize="medium">group_work</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <ForumConsult />,
      },
      {
        name: "Tipos de Ocorrência",
        key: "tipoOcorrencia",
        menu: "c051",
        icon: <Icon fontSize="medium">list_alt</Icon>,
        route: "/pages/cadastro_cobranca/tipos-ocorrencia",
        component: <TipoOcorrenciaConsult />,
      },
      {
        name: "Status",
        key: "statusFicha",
        menu: "c052",
        icon: <Icon fontSize="medium">list_alt</Icon>,
        route: "/pages/cadastro_cobranca/status",
        component: <StatusFichaConsult />,
      },
      {
        name: "Marcações Especiais",
        key: "marcacaoEspecial",
        menu: "c059",
        icon: <Icon fontSize="medium">bookmarks</Icon>,
        route: "/pages/cadastro_geral/marcacoes-especiais",
        component: <MarcacaoEspecialConsult />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Consulta Jurídica",
    key: "processes",
    icon: <Icon fontSize="medium">list_alt</Icon>,
    collapse: [
      {
        name: "Consulta Advogados",
        key: "lawyers",
        menu: "c025",
        icon: <Icon fontSize="medium">gavel</Icon>,
        route: "/pages/processes/lawyers-system",
        component: <LawyersConsult />,
      },
      {
        name: "Consulta Processos",
        key: "process",
        menu: "c026",
        icon: <Icon fontSize="medium">sticky_note_2</Icon>,
        route: "/pages/processes/processes-system",
        component: <ProcessConsult />,
      },
      {
        name: "Consulta Empresas",
        key: "company",
        menu: "c027",
        icon: <Icon fontSize="medium">apartment</Icon>,
        route: "/pages/processes/company-system",
        component: <CompanyConsult />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Ferramentas",
    key: "tools",
    icon: <Icon fontSize="medium">construction</Icon>,
    collapse: [
      {
        name: "Campanhas",
        key: "campanhasAcordo",
        menu: "c060",
        icon: <Icon fontSize="medium">campaign</Icon>,
        route: "/pages/tools/campanhas",
        component: <CampanhaConsult />,
      },
      {
        name: "Usuários",
        key: "user",
        menu: "c004",
        icon: <Icon fontSize="medium">group</Icon>,
        route: "/pages/users/system-users",
        component: <UsersConsult />,
      },
      {
        name: "Equipes",
        key: "team",
        menu: "c031",
        icon: <Icon fontSize="medium">radio_button_checked</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <TeamsConsult />,
      },
      {
        name: "Perfis",
        key: "profile",
        menu: "c003",
        icon: <Icon fontSize="medium">person</Icon>,
        route: "/pages/profile/profile-overview",
        component: <ProfileConsult />,
      },
      {
        name: "Clientes",
        key: "cliente",
        menu: "c043",
        icon: <Icon fontSize="medium">group</Icon>,
        route: "/pages/tcd/tcd-system",
        component: <PessoaConsult />,
      },
      {
        name: "Credenciais de Robô",
        key: "credentials",
        menu: "c006",
        icon: <Icon fontSize="medium">key</Icon>,
        route: "/pages/tools/credentials",
        component: <CredentialConsult />,
      },
      {
        name: "Gravações",
        key: "recordings",
        menu: "c054",
        icon: <Icon fontSize="medium">mic</Icon>,
        route: "/pages/tools/recordings",
        component: <RecordingsConsult />,
      },

      {
        name: "Contas Bancárias",
        key: "contasBancarias",
        menu: "c062",
        icon: <Icon fontSize="medium">account_balance</Icon>,
        route: "/pages/tools/contas-bancarias",
        component: <ContaBancariaConsult />,
      },
      {
        name: "Parametrização do Sistema",
        key: "parametrizacaoSistema",
        menu: "c079",
        icon: <Icon fontSize="medium">settings_suggest</Icon>,
        route: "/pages/tools/parametrizacao-sistema",
        component: <ParametrizacaoSistema />,
      },
      {
        name: "Uso da IA",
        key: "usoIa",
        menu: "c088",
        icon: <Icon fontSize="medium">psychology</Icon>,
        route: "/pages/tools/uso-ia",
        component: <UsoIa />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Suporte",
    key: "suporte",
    icon: <Icon fontSize="medium">support_agent</Icon>,
    collapse: [
      {
        name: "Fila de Solicitações",
        key: "fila-solicitacoes",
        menu: "c067",
        icon: <Icon fontSize="medium">assignment_returned</Icon>,
        route: "/pages/cobranca/fila-solicitacoes",
        component: <FilaSolicitacoesConsult />,
      },
      {
        name: "Importação de Remessa",
        key: "remessaImport",
        menu: "c055",
        icon: <Icon fontSize="medium">upload_file</Icon>,
        route: "/pages/umc/remessa-import",
        component: <RemessaImport />,
      },
      {
        name: "Baixa de Pagamento",
        key: "baixaPagamento",
        menu: "c056",
        icon: <Icon fontSize="medium">price_check</Icon>,
        route: "/pages/tools/baixa-pagamento",
        component: <BaixaPagamentoConsult />,
      },
      {
        name: "Migração de Legado",
        key: "migracaoLegado",
        menu: "c063",
        icon: <Icon fontSize="medium">sync_alt</Icon>,
        route: "/pages/tools/migracao-legado",
        component: <MigracaoLegado />,
        adminOnly: true,
      },
      {
        name: "Migração de Processos",
        key: "migracao-processos",
        menu: "c071",
        icon: <Icon fontSize="medium">upload_file</Icon>,
        route: "/suporte/migracao-processos",
        component: <MigracaoProcessos />,
      },
      {
        name: "Gerar/Importar CNAB",
        key: "cnabSystem",
        menu: "c068",
        icon: <Icon fontSize="medium">account_balance</Icon>,
        route: "/pages/suporte/cnab",
        component: <CnabSystem />,
      },
      {
        name: "Redistribuição de Carteiras",
        key: "redistribuicao-carteira",
        menu: "c074",
        icon: <Icon fontSize="medium">swap_horiz</Icon>,
        route: "/suporte/redistribuicao-carteira",
        component: <RedistribuicaoCarteira />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Robôs",
    key: "robo",
    icon: <Icon fontSize="medium">smart_toy</Icon>,
    collapse: [
      {
        name: "Monitor de Robôs",
        key: "monitorRobos",
        menu: "c083",
        icon: <Icon fontSize="medium">monitor_heart</Icon>,
        route: "/robots/monitor",
        component: <MonitorRobos />,
      },
      {
        name: "Log Robô Edital",
        key: "logroboedital",
        menu: "c016",
        icon: <Icon fontSize="medium">list_alt</Icon>,
        route: "/pages/logroboedital/tcd-system",
        component: <LogRoboEditalConsult />,
      },
      {
        name: "Log Robô Emails Push",
        key: "logroboemails",
        menu: "c017",
        icon: <Icon fontSize="medium">list_alt</Icon>,
        route: "/pages/logroboedital/tcd-system",
        component: <LogRoboEmailsPushConsult />,
      },
      {
        name: "Importar Recortes",
        key: "importMovimentation",
        menu: "c061",
        icon: <Icon fontSize="medium">upload_file</Icon>,
        route: "/pages/tcd/import-movimentation",
        component: <ImportMovimentation />,
      },
      {
        name: "Comparador de Processos(Recortes)",
        key: "comparadorRecortes",
        menu: "c075",
        icon: <Icon fontSize="medium">find_replace</Icon>,
        route: "/robots/comparador-recortes",
        component: <ComparadorRecortes />,
      },
    ],
  },
];

export default routes;
